import Axios from "axios"
import { ConfigObj } from "../models"

const fetchApi = async ({ method = 'GET', url = '', headers = {}, content = {} }) => {
    const configObj = new ConfigObj(method, url, headers, content)

    try {
        const res = await Axios(configObj.axiosObj)
        return res.data

    } catch (err) {
        throw err
    }
}

export { fetchApi }